const AccessContext = require('../contexts/access-context');

const SocialCampaign = require('../../entities/social-campaign');

const fields = ['type', 'enabled', 'name', 'description', 'contentType', 'active'];
const createFields = ['type', 'enabled', 'name', 'description', 'contentType'];

class SocialCampaignsRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context; // eslint-disable-next-line no-use-before-define

    this.for = (id
    /*: campaignId*/
    ) => new SocialCampaignRepo(client, id, this.context);

    this.icanhas = this.for;
  }

  list(_, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/campaigns`, {}, options.fields || fields);
    req.parse = SocialCampaign.parse;
    return this.client.get(req);
  }

  create(campaign
  /*: SocialCampaign*/
  , options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/campaigns/${campaign.type}`, campaign, options.fields || createFields);
    req.serialize = SocialCampaign.serialize;
    req.parse = SocialCampaign.parse;
    return this.client.post(req);
  }

}

class SocialCampaignRepo {
  constructor(client
  /*: ApiClient*/
  , id
  /*: campaignId*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.id = id;
    this.context = context;
  }

  update(updates
  /*: SocialCampaign*/
  , options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/campaigns/${this.id}`, updates, options.fields || fields);
    req.serialize = SocialCampaign.serialize;
    req.parse = SocialCampaign.parse;
    return this.client.patch(req);
  }

  enable(_, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/campaigns/${this.id}/enable`);
    return this.client.post(req);
  }

  disable(_, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/campaigns/${this.id}/disable`);
    return this.client.post(req);
  }

  delete(_, options
  /*: RequestOptions*/
  = {}) {
    const {
      businessId
    } = this.context.serialize();
    const req = new this.client.Request(`/businesses/${businessId}/social/profile/campaigns/${this.id}`);
    return this.client.delete(req);
  }

}

module.exports = SocialCampaignsRepo;